import React, { useState } from 'react';
import { Input, Dropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  StyledDropdownMenu,
  StyledDropdownItem,
  StyledDropdownToggle
} from './SourceDropDown.styled';

const SourceDropDown = ({
  disabled,
  sources,
  onSourceSelected,
  defaultValue,
  sourceType
}) => {
  const [selected, setSelected] = useState(defaultValue);
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  const handleSelected = value => {
    setSelected(value);
    onSourceSelected(value);
  };

  const truncateTitle = (str, num) => {
    if (str.length > num) {
      let subStr = str.substring(0, num);
      return subStr + '...';
    } else {
      return str;
    }
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <StyledDropdownToggle
        data-testid="source-action-toggle"
        disabled={disabled}
        color={'light'}
        caret
      >
        {selected
          ? truncateTitle(selected.title || 'No Title', 12)
          : `Select ${sourceType}`}
      </StyledDropdownToggle>
      <StyledDropdownMenu>
        {sources.map((source, index) => (
          <StyledDropdownItem
            selected={selected && selected._id === source._id}
            key={index}
            onClick={() => handleSelected(source)}
          >
            <Input
              defaultChecked={selected && selected._id === source._id}
              type="radio"
              name="sources"
            />
            <div>{`${
              source.title ? truncateTitle(source.title, 50) : 'No Title'
            }`}</div>
          </StyledDropdownItem>
        ))}
      </StyledDropdownMenu>
    </Dropdown>
  );
};

SourceDropDown.defaultProps = {
  sources: [],
  disabled: false,
  defaultValue: {},
  sourceType: 'source'
};

SourceDropDown.propTypes = {
  disabled: PropTypes.bool.isRequired,
  defaultValue: PropTypes.object,
  sources: PropTypes.array.isRequired,
  onSourceSelected: PropTypes.func.isRequired,
  sourceType: PropTypes.string
};

export default SourceDropDown;
